import React, { useContext, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { TrackerDetailsContext } from 'pages/policyCenter/trackers/context'
import { InfoRow, TextInput } from '@ketch-com/deck'
import { RoutesManager } from 'utils/routing/routesManager'
import { NavigationBreadCrumbs } from 'components/appLayout/appNavigation/breadcrumbs/NavigationBreadCrumbs'
import { useIsPermitted } from 'utils/hooks/useIsPermitted'
import { PERMISSIONS } from 'interfaces/permissions/permissions'
import { DisclosureTranslations } from 'pages/policyCenter/trackers/details/components/disclosure/DisclosureTranslations'

export const Disclosure: React.FC = () => {
  const { isPermitted: getIsPermitted } = useIsPermitted()
  const isPermittedToWriteCookie = getIsPermitted([PERMISSIONS.COOKIE_WRITE])
  const {
    trackerDetails,
    orgLanguages,
    encodedTrackerKey = '',
    updateTrackerDisclosure,
    isUpdatingTrackerDisclosure,
    disclosure,
  } = useContext(TrackerDetailsContext)
  const description = disclosure?.en?.description
  const [isEditing, setIsEditing] = useState(false)
  const [currentDisclosure, setCurrentDisclosure] = useState<string>(description)
  const [previousDisclosure, setPreviousDisclosure] = useState<string>('')

  return (
    <Box>
      <NavigationBreadCrumbs
        type="dark"
        items={[
          { title: 'Privacy Program', link: RoutesManager.policyCenter.root.getURL() },
          { title: 'Trackers', link: RoutesManager.policyCenter.trackers.list.approvedTrackers.root.getURL() },
          { title: trackerDetails?.key },
          { title: 'Disclosure' },
        ]}
      />
      <Box mb={6} display="flex" flexDirection="column" gap={3}>
        <Box>
          <Typography variant="h3">Description</Typography>
          <Typography variant="body" color="darkDuskFaded.main">
            Tracker description that will appear in experiences.
          </Typography>
        </Box>
        <InfoRow
          title="Disclosed Description"
          isEditable={isPermittedToWriteCookie ? true : false}
          isEditing={isEditing}
          isLoading={isUpdatingTrackerDisclosure}
          onEditChange={() => {
            setIsEditing(true)
            setPreviousDisclosure(description)
          }}
          onAcceptChange={() => {
            updateTrackerDisclosure({
              params: { requestBody: { ...disclosure, en: { description: currentDisclosure } }, encodedTrackerKey },
            })
            setIsEditing(false)
          }}
          onCancelChange={() => {
            setCurrentDisclosure(previousDisclosure)
            setIsEditing(false)
          }}
          onDeleteChange={() => {
            updateTrackerDisclosure({
              params: { requestBody: { ...disclosure, en: { description: '' } }, encodedTrackerKey },
            })
            setIsEditing(false)
          }}
          isEmpty={!!!description?.length}
        >
          {isEditing ? (
            <TextInput
              autoFocus
              placeholder="None"
              multiline={true}
              rows={2}
              fullWidth={true}
              value={currentDisclosure}
              onChange={event => setCurrentDisclosure(event.target.value)}
            />
          ) : description ? (
            description
          ) : (
            'None'
          )}
        </InfoRow>
      </Box>

      {orgLanguages?.length > 0 && (
        <Box display="flex" flexDirection="column" gap={3}>
          <Typography variant="h3">Translations</Typography>

          <Box display="flex" flexDirection="column" gap={4}>
            {orgLanguages?.map(({ language }) => {
              return <DisclosureTranslations key={`${language.code}-disclosure-description`} language={language} />
            })}
          </Box>
        </Box>
      )}
    </Box>
  )
}
